(() => {
  const init = () => {
    const headerSection = document.querySelector('.shopify-section--header[id^="shopify-section-"]');
    if (!headerSection) return;

    const storeHeader = headerSection.querySelector('store-header');
    const wrapper = headerSection.querySelector('.header__wrapper');

    if (wrapper) {
      const syncHeaderHeights = () => {
        const headerHeight = headerSection.clientHeight;
        const headerHeightWithoutBottomNav = wrapper.clientHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        document.documentElement.style.setProperty('--header-height-without-bottom-nav', `${headerHeightWithoutBottomNav}px`);
      };

      syncHeaderHeights();
      window.addEventListener('resize', syncHeaderHeights, { passive: true });
    }

    if (!storeHeader) return;

    const mq = window.matchMedia('(max-width: 999px)');
    const initiallySticky = storeHeader.hasAttribute('sticky');

    const syncStickyAttribute = () => {
      if (!initiallySticky) return;
      if (mq.matches) storeHeader.removeAttribute('sticky');
      else storeHeader.setAttribute('sticky', '');
    };

    syncStickyAttribute();
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', syncStickyAttribute);
    else mq.addListener(syncStickyAttribute);

    if (initiallySticky) {
      const clearMobileToolbarStickyTop = () => {
        if (!mq.matches) {
          document.documentElement.style.removeProperty('--mobile-toolbar-sticky-top');
        }
      };
      mq.addEventListener('change', clearMobileToolbarStickyTop);
    }

    if (!initiallySticky || !mq.matches) return;

    const announcementSection = document.querySelector('.shopify-section--announcement-bar');
    if (announcementSection) headerSection.classList.add('has-announcement');

    const syncMobileToolbarStickyTop = () => {
      if (!wrapper || !mq.matches) {
        return;
      }
      const bottom = wrapper.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--mobile-toolbar-sticky-top', `${Math.round(bottom)}px`);
    };

    let ticking = false;
    const update = () => {
      ticking = false;
      const scrollY = window.scrollY || 0;
      headerSection.classList.toggle('is-mobile-sticky-collapsed', scrollY > 0);

      if (announcementSection) {
        const rect = announcementSection.getBoundingClientRect();
        const isVisibleAtTop = rect.bottom > 0 && rect.top <= 0;
        headerSection.classList.toggle('is-offset-by-announcement', isVisibleAtTop);
      } else {
        headerSection.classList.remove('is-offset-by-announcement');
      }

      if (storeHeader.getAttribute('data-header-layout') === 'logo_left_search_center') {
        const searchBar = headerSection.querySelector('.header__search-bar');
        const divider = headerSection.querySelector('.header__divider');
        const fullHeight = wrapper ? wrapper.scrollHeight : 0;
        const topHeight =
          fullHeight - (searchBar ? searchBar.offsetHeight : 0) - (divider ? divider.offsetHeight : 0);

        const stickyHeight = scrollY === 0 ? fullHeight : Math.max(topHeight - 5, 0);
        document.documentElement.style.setProperty('--header-sticky-height', `${stickyHeight}px`);
      } else {
        document.documentElement.style.removeProperty('--header-sticky-height');
      }

      requestAnimationFrame(() => syncMobileToolbarStickyTop());
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
